import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueTypeFieldLabel: {
		id: 'issue-create.modal.create-form.type-picker.issue-type-field-label',
		defaultMessage: 'Issue type',
		description: 'Label for issue type field in issue create form',
	},
	requestTypeFieldLabel: {
		id: 'issue-create.modal.create-form.type-picker.request-type-field-label',
		defaultMessage: 'Request type',
		description: 'Label for request type field in issue create form',
	},
	typeFieldLabel: {
		id: 'issue-create.modal.create-form.type-picker.type-field-label',
		defaultMessage: 'Type',
		description: 'Label for issue type field in issue create form',
	},
	issueTypeGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.issue-type-group-label',
		defaultMessage: 'Issue types',
		description: 'Label for issue types group in type field',
	},
	requestTypeGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.request-type-group-label',
		defaultMessage: 'Request types',
		description: 'Label for request types group in type field',
	},
	unassignedRequestTypeGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.unassigned-request-type-group-label',
		defaultMessage: 'Unassigned',
		description:
			'Label for unassigned request types group in type field (It contains request types that are not assigned to any ITSM category)',
	},
	serviceRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.service-request-group-label',
		defaultMessage: 'Service requests',
		description: 'Label for services requests group in type field',
	},
	incidentRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.incident-request-group-label',
		defaultMessage: 'Incidents',
		description: 'Label for incident requests group in type field',
	},
	postIncidentReviewRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.post-incident-review-request-group-label',
		defaultMessage: 'Post-incident reviews',
		description: 'Label for post-incident reviews requests group in type field',
	},
	developerEscalationRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.developer-escalation-request-group-label',
		defaultMessage: 'Developer escalations',
		description: 'Label for developer escalations reviews requests group in type field',
	},
	problemRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.problem-request-group-label',
		defaultMessage: 'Problems',
		description: 'Label for problem requests group in type field',
	},
	changeRequestGroupLabel: {
		id: 'issue-create.modal.create-form.type-picker.change-request-group-label',
		defaultMessage: 'Changes',
		description: 'Label for change requests group in type field',
	},
	noRequestTypeLabel: {
		id: 'issue-create.modal.create-form.type-picker.no-request-type-label',
		defaultMessage: 'No request type',
		description: 'Label for picking no request type in the request type field in issue create form',
	},
	issueTypeHelpText: {
		id: 'issue-create.modal.create-form.type-picker.issue-type-help-text',
		defaultMessage: 'Learn more',
		description: 'Help text for issue type field',
	},
	issueTypeFieldLabelIssueTermRefresh: {
		id: 'issue-create.modal.create-form.type-picker.issue-type-field-label-issue-term-refresh',
		defaultMessage: 'Work type',
		description: 'Label for issue type field in issue create form',
	},
	issueTypeGroupLabelIssueTermRefresh: {
		id: 'issue-create.modal.create-form.type-picker.issue-type-group-label-issue-term-refresh',
		defaultMessage: 'Work types',
		description: 'Label for issue types group in type field',
	},
});
